import React from 'react'
import ReactLoading from 'react-loading'

export const Loader = () => (
  <ReactLoading color='black' type='bubbles' />
)

Loader.propTypes = {}

export default Loader
